import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18next';
import { openWindow } from 'client/utils/login';
import { signout, getLoginPageUrl } from 'editor/utils/firebaseManager';
import { setWarning, setFailed } from 'editor/redux/modules/notify';
import { PROMO_NAME_INCLUDE_SPECIAL_SYMBOL, EXCEPTION_FAILED } from 'config/editErrorTypes';

export default function useApiFailedHandler() {
    const dispatch = useDispatch();

    return useCallback(
        (err = {}, defaultErrMsg = 'notify.save_failed') => {
            console.log('Api request failed: ', err);
            switch (true) {
                case err.httpStatus === 401: {
                    function promptLogin() {
                        dispatch(setFailed(i18n.t('notify.save_failed')));
                        dispatch(setWarning(i18n.t('notify.login_session_expired')));
                        openWindow(
                            getLoginPageUrl(`${window.location.origin}/promotions/editorlogin`),
                            { name: 'editor-login' }
                        );
                    }
                    signout().then(promptLogin).catch(promptLogin);
                    break;
                }
                case err.httpStatus === 403:
                    window.location.replace('/app/permission_denied');
                    break;
                case err.message === PROMO_NAME_INCLUDE_SPECIAL_SYMBOL:
                    dispatch(setFailed(i18n.t('label.error.promo_name_include_special_symbol')));
                    break;
                default:
                    dispatch(setFailed(i18n.t(defaultErrMsg)));
                    break;
            }
        },
        [dispatch]
    );
}

export function generateApiErrObj(apiErr = {}, type = EXCEPTION_FAILED, body) {
    let errObj = new Error(type);
    apiErr.errType = type;
    errObj.extraInfo = apiErr;

    if (!Array.isArray(apiErr) && typeof apiErr === 'object' && Boolean(body)) {
        errObj.extraInfo.body = body;
    }

    return errObj;
}
